export default __webpack_public_path__ + "static/media/distortion_sl_init.6b50e62c.png";